import React from "react";

import clsx from "clsx";
import 'leaflet/dist/leaflet.css';
import { useTheme } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

// Iconos (algunos van a volar con los menues nuevos)
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import AyacuchoIcon from "../assets/images/ayacucho/lg.png";
import QueryStatsIcon from '@mui/icons-material/QueryStats';

// Viejo
import LiveStats from "./mobility/stats/LiveStats.js";

// Menus nuevos
import Style from "../styles/js/Styles.js";

import DevMenu from "./developer/menu.jsx";
import DevRouter from "./developer/router.jsx";
import UsersMenu from "./users/menu.jsx";
import UsersRouter from "./users/router.jsx";
import ShifterMenu from "./services/shifter/menu.jsx";
import ShifterRouter from "./services/shifter/router.jsx";
import NoticesMenu from "./services/notices/menu.jsx";
import NoticesRouter from "./services/notices/router.jsx";
import MapsMenu from "./map/menu.jsx";
import MapsRouter from "./map/router.jsx";
import CallsMenu from "./services/calls/menu.jsx";
import CallsRouter from "./services/calls/router.jsx";
import CultureMenu from "./services/ads/menu.jsx";
import CultureRouter from "./services/ads/router.jsx";
import EmergencyMenu from "./services/emergency/menu.jsx";
import EmergencyRouter from "./services/emergency/router.jsx";
import ResiduesMenu from "./services/residues/menu.jsx";
import ResiduesRouter from "./services/residues/router.jsx";


// Authenticacion
import auth from "../plas/auth/service";

import {
  Switch,
  Route,
  Link
} from "react-router-dom";

export default function Index( { history } ) {
  const style = Style();
  const theme = useTheme();

  const [open, setOpen] = React.useState(false);

  const expand = () => {
    if (!open) {
      setOpen(true)
    }
  }
  
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleLogOut = () => {
    auth.clearSession();
    history.push("/login");
  };

  const listenSession = () => {
    auth.setSessionListener({
      invalidPassword: () => {
        handleLogOut();
      }
    })
  }
  
  React.useEffect(() => {
    if (auth.hasSession())
      listenSession();
    else
      handleLogOut();
  }, []);

  return (
    <div className={style.root} style={{height : "100%"}}>

      <AppBar
        position="fixed"
        className={clsx(style.appBar, {
          [style.appBarShift]: open,
        })}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(style.menuButton, {
              [style.hide]: open,
            })}
          >
            <MenuIcon />
          </IconButton>
          <img
            src={AyacuchoIcon}
            alt="Municipalidad de Ayacucho"
            className={style.image}
          />
          <Typography variant="h6" style={{ color: "#9d9d9d" }} noWrap>
            APS - Ayacucho Plataforma de Servicios
          </Typography>
        </Toolbar>
      </AppBar>

      <Drawer
        variant="permanent"
        classes={{
          paper: clsx({
            [style.drawerOpen]: open,
            [style.drawerClose]: !open,
          }),
        }}>
        <div className={style.toolbar}>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
        </div>
        <Divider />
        <List>

          <EmergencyMenu open={open} onExpand={expand}/>

          <DevMenu open={open} onExpand={expand}/>

          <NoticesMenu open={open} onExpand={expand}/>

          <CultureMenu open={open} onExpand={expand}/>

          <UsersMenu open={open} onExpand={expand}/>

          <MapsMenu open={open} onExpand={expand}/>

          <ShifterMenu open={open} onExpand={expand}/>

          <CallsMenu open={open} onExpand={expand}/>

          <ResiduesMenu open={open} onExpand={expand}/>

          {auth.canStatsAccess() ? (
            <ListItem button component={Link} to={"/mobility/stats/live"}>
              <ListItemIcon>
                <QueryStatsIcon />
              </ListItemIcon>
              <ListItemText className={style.menuTextItem}  primary="Estadísticas" />
            </ListItem>
          ) : null}
          
          <ListItem button component={Link} to={"/login"} onClick={handleLogOut}>
            <ListItemIcon>
              <ExitToAppIcon />
            </ListItemIcon>
            <ListItemText className={style.menuTextItem} primary="Cerrar sesión" />
          </ListItem>

        </List>
      </Drawer>

      <main className={style.content} >
        <div className={style.toolbar} />
        <Switch>
          
          <Route path="/users">
            <UsersRouter base={"/users"} />
          </Route>
          <Route path="/mobility/stats/live">
            <LiveStats />
          </Route>
          <Route path="/dev">
            <DevRouter base={"/dev"} />
          </Route>
          <Route path="/calls">
            <CallsRouter base={"/calls"} />
          </Route>
          <Route path="/map">
            <MapsRouter base={"/map"} />
          </Route>
          <Route path="/notices">
            <NoticesRouter base={"/notices"}/>
          </Route>
          <Route path="/shifter">
            <ShifterRouter base={"/shifter"}/>
          </Route>
          <Route path="/culture">
            <CultureRouter base={"/culture"}/>
          </Route>
          <Route path="/emergency">
            <EmergencyRouter base={"/emergency"}/>
          </Route>
          <Route path="/residues">
            <ResiduesRouter base={"/residues"}/>
          </Route>
        </Switch>
      </main>
      
    </div>
  );
}
